/**
 * Canonical count of the product's tools.
 *
 * Every "N tools" claim in marketing copy, FAQ text and structured data must
 * derive from this list rather than restate the number as a literal — a
 * literal repeated in eight hand-maintained places drifted out of date once
 * already (it said "nine" after Cover Letter and AI Prompts shipped, both of
 * which are real tools with real pages/tabs, making the true count eleven).
 *
 * AI Resume Prompts was dropped from this list on 2026-09-25 along with its
 * public /resume-prompts page. The prompt pack still exists as a tab inside
 * the builder, but it is no longer marketed as one of the standalone tools.
 *
 * Deliberately its own zero-dependency module: the full tool registry lives in
 * `AnalysisPanel.tsx`, which pulls in the analysis engine and Motion and must
 * stay out of the marketing pages' bundle. This file is safe to import from
 * anywhere, including prerendered/static content, without that cost.
 */
export const TOOL_NAMES = [
  'ATS Resume Checker',
  'Job Description Matcher',
  'Bullet Point Improver',
  'Achievement Quantifier',
  'Summary Builder',
  'Completeness Checker',
  'Duplicate Detector',
  'Length Advisor',
  'Plain Text ATS Preview',
  'Cover Letter Assistant',
] as const

export const TOOL_COUNT = TOOL_NAMES.length
